import { SquareRoundedBadgeOutlineIcon } from './SquareRoundedBadgeOutlineIcon';

/**
 * author: Jeff Anders
 * id 336D96D3-5E97-434B-BEF7-651BF94FA347
 * name square-rounded-badge-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-rounded-badge-outline.svg
 * tags
 * - Shape 
 * - Notification 
 */
export const PushNotificationOutlineIcon = SquareRoundedBadgeOutlineIcon;
export default PushNotificationOutlineIcon